import React from 'react';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';

// GLOBAL HELPERS
import { getListData } from 'helpers/getListData.js';

// CORE COMPONENTS
import Form from 'core/form/Form';

// GLOBAL PARTS
import Main from 'parts/main/Main';
import Title from 'parts/title/Title';
import { Filters } from 'parts/table/Table.js';

// LOCAL COMPONENTS
import DailySalesTable from './parts/DailySalesTable.js';
import VehicleInfoSidebar from './parts/VehicleInfoSidebar.js';
import CurrentDate from './parts/CurrentDate.js';

// MAIN COMPONENT
const DailySales = () => (
  <Main>
    <Title documentTitle="Daily Sales " title="Daily Sales" />
    <CurrentDate />
    <Filters>
      <Filters.Date name="saleDate" placeholder="Sale Date" maxDate={new Date()} />
      <Filters.Button.NewUsed />
    </Filters>
    <DailySalesTable />
    <VehicleInfoSidebar />
  </Main>
);

// EXPORT
export default getListData(DailySales, {
  key: 'dailySales',
  fetchArgs: {
    endpoint: ENDPOINTS.dailySales.listByDate
  },
  defaults: {
    saleDate: Form.Date.OPTIONS.today.date
  }
});
